import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import i18next from "../../i18n/i18n";

export type SourcePage = "chat" | "feedback";

interface SessionNotFoundProps {
    open: boolean;
    sourcePage: SourcePage;
    onConfirm: () => void;
}

function getDialogContent(sourcePage: SourcePage) {
    return {
        title: i18next.t("sessionNotFound.sessionNotFoundTitle"),
        message: i18next.t("sessionNotFound.sessionNotFoundMessage")
    };
}

const SessionNotFound: React.FC<SessionNotFoundProps> = ({ open, sourcePage, onConfirm }) => {
    const { title, message } = getDialogContent(sourcePage);
    const okLabel = i18next.t("chat.ok");
    const handleDialogClose = (event: object, reason: string) => {
        // Prevent closing on backdrop click or escape key
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
    };
    return (
        <Dialog open={open} onClose={handleDialogClose} aria-labelledby="session-not-found-title" disableEscapeKeyDown>
            <DialogTitle id="session-not-found-title">{title}</DialogTitle>
            <DialogContent>
                <p>{message}</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={onConfirm} color="primary" autoFocus>
                    {okLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionNotFound;
